<div
  class="
    fusion-fullwidth
    fullwidth-box
    fusion-builder-row-1 fusion-parallax-none
    nonhundred-percent-fullwidth
    non-hundred-percent-height-scrolling
  "
  style="
    background-color: rgba(255, 255, 255, 0);
    background-image: url('/wp-content/uploads/2015/12/about-call-to-action-57862405-1024x630.jpg');
    background-position: center bottom;
    background-repeat: no-repeat;
    padding-top: 150px;
    padding-right: 30px;
    padding-bottom: 0px;
    padding-left: 30px;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  "
>
  <div class="fusion-builder-row fusion-row">
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_1
        fusion-builder-column-0
        fusion-one-full
        fusion-column-first
        fusion-column-last
        1_1
      "
      style="margin-top: 0px; margin-bottom: 0px"
    >
      <div
        class="fusion-column-wrapper"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <style type="text/css">
          @media only screen and (max-width: 800px) {
            .fusion-title.fusion-title-1 {
              margin-top: 10px !important;
              margin-bottom: 10px !important;
            }
          }
        </style>
        <div
          class="
            fusion-title
            title
            fusion-title-1
            fusion-sep-none
            fusion-title-text
            fusion-title-size-one
          "
          style="margin-top: 0px; margin-bottom: 10px"
        >
          <h1 class="title-heading-left" style="margin: 0">
            <h1 style="text-align: center">
              <span style="color: #ffffff">GARE IN CORSO</span>
            </h1>
            <h4>
              <span style="color: #ffffff">Alcune gare, create da Professionisti o Committenti, possono essere gestite in modalità “RISERVATA”, in tal caso la partecipazione delle imprese avviene solo su invito tramite la vetrina.
              </span>
            </h4>
          </h1>
        </div>
        <div class="fusion-clearfix"></div>
      </div>
    </div>
    <form [formGroup]="searchForm" id="search-appform">
      <style type="text/css">
        input::-webkit-input-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-webkit-input-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Firefox < 19 */
        input:-moz-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-moz-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Firefox > 19 */
        input::-moz-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-moz-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Internet Explorer 10 */
        input:-ms-input-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-ms-input-placeholder {
          color: #ffffff;
          transition: none;
        }
      </style>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_2_5
          fusion-builder-column-1
          fusion-two-fifth
          fusion-column-first
          2_5
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 40%;
          width: calc(40% - ((4% + 4%) * 0.4));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper"
          style="
            background-color: #ffffff;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <ul
            class="fusion-checklist fusion-checklist-1"
            style="font-size: 16px; line-height: 27.2px; padding: 3px"
          >
            <li class="fusion-li-item">
              <span
                style="
                  height: 27.2px;
                  width: 27.2px;
                  margin-right: 11.2px;
                  margin-right: 10px;
                  padding-top: 5px;
                  padding-right: 0;
                  padding-left: 10px;
                "
                class="icon-wrapper circle-no"
                ><i
                  class="fusion-li-icon fa-building fas"
                  style="color: #333333; padding-top: 15px; padding-left: 8px"
                ></i
              ></span>
              <div class="fusion-li-item-content" style="margin-left: 45px">
                <select
                  formControlName="tenderCategory"
                  style="
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    font-size: 16px !important;
                    font-weight: 300;
                    letter-spacing: 1px !important;
                    padding-bottom: 0 !important;
                    padding-left: 5px !important;
                  "
                >
                  <!-- <option [ngValue]="defaultCategory" disabled selected hidden>{{defaultCategory.description}}</option> -->
                  <option [ngValue]="null">Tutte le categorie</option>
                  <option
                    [ngValue]="tenderCategory.code"
                    *ngFor="let tenderCategory of tenderCategories"
                  >
                    {{ tenderCategory.description }}
                  </option>
                </select>
              </div>
            </li>
          </ul>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_2_5
          fusion-builder-column-2
          fusion-two-fifth
          2_5
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 40%;
          width: calc(40% - ((4% + 4%) * 0.4));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper"
          style="
            background-color: #ffffff;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <ul
            class="fusion-checklist fusion-checklist-2"
            style="font-size: 16px; line-height: 27.2px; padding: 3px"
          >
            <li class="fusion-li-item">
              <span
                style="
                  height: 27.2px;
                  width: 27.2px;
                  margin-right: 11.2px;
                  margin-right: 10px;
                  padding-top: 5px;
                  padding-right: 0;
                  padding-left: 10px;
                "
                class="icon-wrapper circle-no"
                ><i
                  class="fusion-li-icon fa-map-marker-alt fas"
                  style="color: #333333; padding-top: 15px; padding-left: 8px"
                ></i
              ></span>
              <div class="fusion-li-item-content" style="margin-left: 45px">
                <input
                  style="
                    font-size: 16px !important;
                    font-weight: 300;
                    letter-spacing: 1px !important;
                    padding-bottom: 0 !important;
                    padding-left: 5px !important;
                  "
                  class="ng-app-input"
                  type="text"
                  formControlName="location"
                  placeholder="LOCALITA&#8217; (Città, Provincia o Cap)"
                />
              </div>
            </li>
          </ul>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_5
          fusion-builder-column-3
          fusion-one-fifth
          fusion-column-last
          1_5
        "
        style="
          margin-top: 10px;
          margin-bottom: 0px;
          width: 20%;
          width: calc(20% - ((4% + 4%) * 0.2));
        "
      >
        <div
          class="fusion-column-wrapper"
          style="
            padding: 10px 10px 10px 10px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-1 {
                border-radius: 0px;
              }</style
            ><a
              (click)="searchOngoingTenders()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-1
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text">CERCA</span></a
            >
          </div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_1
          fusion-builder-column-4
          fusion-one-full
          fusion-column-first
          fusion-column-last
          1_1
        "
        style="margin-top: 0px; margin-bottom: 0px"
      >
        <div
          class="fusion-column-wrapper"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-sep-clear"></div>
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 100px"
          ></div>
          <div
            class="
              fusion-section-separator
              section-separator
              big-half-circle
              fusion-section-separator-with-offset
            "
            style="
              padding: 0;
              margin-left: calc((100vw - 100%) / -2);
              margin-right: calc((100vw - 100%) / -2);
            "
          >
            <svg
              class="fusion-big-half-circle-candy"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              width="100%"
              height="100"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              style="fill: #ffffff; padding: 0"
            >
              <path d="M0 100 C40 0 60 0 100 100 Z"></path>
            </svg>
          </div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </form>
  </div>
</div>
<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-1
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link),
  .fusion-fullwidth.fusion-builder-row-1
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):before,
  .fusion-fullwidth.fusion-builder-row-1
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover,
  .fusion-fullwidth.fusion-builder-row-1
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-1
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-1
    .fusion-filters
    .fusion-filter.fusion-active
    a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1
    .fusion-filters
    .fusion-filter.fusion-active
    a,
  .fusion-fullwidth.fusion-builder-row-1
    .fusion-date-and-formats
    .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-1 .tooltip-shortcode {
    color: #ffa626;
  }

  #main
    .fusion-fullwidth.fusion-builder-row-1
    .post
    .blog-shortcode-post-title
    a:hover {
    color: #ffa626;
  }
</style>

<h2 *ngIf="isInvitation" style="text-align: center">
  Sei stato invitato alla seguente gara
</h2>

<div
  *ngIf="!publicTenderCards || publicTenderCards.length === 0"
  style="text-align: center; margin-top: 8vh; margin-bottom: 8vh"
>
  <p style="font-size: 2rem"><strong>Le gare in corso sono in modalità RISERVATA</strong></p>
</div>
<div *ngFor="let tenderCard of publicTenderCards">
  <div
    class="
      fusion-fullwidth
      fullwidth-box
      fusion-builder-row-2
      nonhundred-percent-fullwidth
      non-hundred-percent-height-scrolling
      fusion-equal-height-columns
    "
    style="
      background-color: rgba(255, 255, 255, 0);
      background-position: center center;
      background-repeat: no-repeat;
      padding-top: 0px;
      padding-right: 30px;
      padding-left: 30px;
      margin-bottom: 30px;
    "
  >
    <div
      class="fusion-builder-row fusion-row"
      style="background-color: var(--ng-app-mid-grey-color)"
    >
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_4
          fusion-builder-column-5
          fusion-one-fourth
          fusion-column-first
          1_4
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 25%;
          width: calc(25% - ((0px) * 0.25));
          margin-right: 0px;
        "
      >
        <div
          class="fusion-column-wrapper"
          style="
            background-color: #efefef;
            padding: 30px 50px 10px 50px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="imageframe-align-center">
            <span
              class="
                fusion-imageframe
                imageframe-none imageframe-1
                hover-type-none
              "
              ><img
                src="{{ getCategoryImageUrl(tenderCard.category) }}"
                width="300"
                height="300"
                class="img-responsive wp-image-1307"
            /></span>
          </div>
          <div class="fusion-sep-clear"></div>
          <div
            class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 15px"
          ></div>
          <ul
            class="fusion-checklist fusion-checklist-3"
            style="font-size: 16px; line-height: 27.2px"
            *ngIf="tenderCard.attachments && tenderCard.attachments.length > 0"
          >
            <li class="fusion-li-item">
              <span
                style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                class="icon-wrapper circle-no"
                ><i
                  class="fusion-li-icon fa-images fas"
                  style="color: #333333"
                ></i
              ></span>
              <div class="fusion-li-item-content" style="margin-left: 38.4px">
                <p><strong style="color: #ffa626">Scarica Allegati</strong></p>
              </div>
            </li>
          </ul>
          <div
            style="
              background-color: var(--ng-app-light-grey-color);
              padding: 10px;
              max-height: 95px;
              overflow: auto;
              margin-bottom: 5px;
            "
            *ngIf="tenderCard.attachments && tenderCard.attachments.length > 0"
          >
            <div *ngFor="let attachment of getAttachmentList(tenderCard)">
              <div style="display: flex; justify-content: space-between">
                <p
                  style="
                    font-size: 15px;
                    font-weight: 500;
                    margin-bottom: 0px;
                    padding-left: 3px;
                    padding-bottom: 3px;
                  "
                >
                  {{ attachment.name }}
                </p>
                <i
                  (click)="openAttachmentUrl(attachment.url)"
                  class="fas fa-download fa-sm"
                  style="
                    cursor: pointer;
                    color: var(--ng-app-theme-yellow-color);
                  "
                ></i>
              </div>
            </div>
          </div>
          <span
            *ngIf="
              !tenderCard.attachments || tenderCard.attachments.length === 0
            "
            style="cursor: auto"
            class="fusion-popover popover-1"
            data-animation="1"
            data-class="popover-1"
            data-container="popover-1"
            data-content="Allegati disponibili solo per chi acquista la Gara"
            data-delay="50"
            data-placement="top"
            data-toggle="popover"
            data-trigger="hover"
          >
            <ul
              class="fusion-checklist fusion-checklist-3"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa-images fas"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p style="color: var(--ng-app-dark-grey-color)">
                    <strong>Scarica Allegati</strong>
                  </p>
                </div>
              </li>
            </ul>
          </span>
          <span
            *ngIf="tenderCard.metricCalculationDoc"
            (click)="
              openAttachmentUrl(tenderCard.metricCalculationDoc.documentUrl)
            "
            class="fusion-popover popover-2"
          >
            <ul
              class="fusion-checklist fusion-checklist-4"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa-file-excel fas"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p><strong>Scarica Computo</strong></p>
                </div>
              </li>
            </ul>
          </span>

          <!--  <span class="fusion-popover popover-2" data-animation="1" data-class="popover-2" data-container="popover-2"
                    data-content="Computo metrico disponibile solo per chi acquista la Gara" data-delay="50" data-placement="top"
                    data-toggle="popover" data-trigger="hover">
                    <style type="text/css">
                        .popover-2 .popover-title {}

                        .popover-2 .popover-content {}
                    </style>
                    <ul class="fusion-checklist fusion-checklist-4" style="font-size:16px;line-height:27.2px;">
                        <li class="fusion-li-item"><span style="height:27.2px;width:27.2px;margin-right:11.2px;"
                                class="icon-wrapper circle-no"><i class="fusion-li-icon fa-file-excel fas"
                                    style="color:#333333;"></i></span>
                            <div class="fusion-li-item-content" style="margin-left:38.4px;">
                                <p><strong>Scarica Computo</strong></p> -->

          <span
            *ngIf="!tenderCard.metricCalculationDoc"
            style="cursor: auto"
            class="fusion-popover popover-2"
            data-animation="1"
            data-class="popover-2"
            data-container="popover-2"
            data-content="Computo metrico disponibile solo per chi acquista la Gara"
            data-delay="50"
            data-placement="top"
            data-toggle="popover"
            data-trigger="hover"
          >
            <ul
              class="fusion-checklist fusion-checklist-4"
              style="font-size: 16px; line-height: 27.2px"
            >
              <li class="fusion-li-item">
                <span
                  style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                  class="icon-wrapper circle-no"
                  ><i
                    class="fusion-li-icon fa-file-excel fas"
                    style="color: #333333"
                  ></i
                ></span>
                <div class="fusion-li-item-content" style="margin-left: 38.4px">
                  <p style="color: var(--ng-app-dark-grey-color)">
                    <strong>Scarica Computo</strong>
                  </p>
                </div>
              </li>
            </ul>
          </span>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_3_4
          fusion-builder-column-6
          fusion-three-fourth
          fusion-column-last
          3_4
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 75%;
          width: calc(75% - ((0px) * 0.75));
        "
      >
        <div
          class="fusion-column-wrapper"
          style="
            background-color: #efefef;
            padding: 30px 30px 0px 30px;
            min-height: 300px !important;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <div class="fusion-text">
            <div style="display: flex; justify-content: space-between">
              <p>
                <strong>{{ tenderCard.title }}</strong>
              </p>
              <p
                *ngIf="tenderCard.bestOffer"
                style="
                  border: 2px solid var(--ng-app-theme-yellow-color);
                  padding: 0 5px;
                  font-size: 18px;
                  font-weight: 500;
                  font-style: italic;
                "
              >
                Miglior offerta: &euro;
                {{ tenderCard.bestOffer | currency: "EUR":"":"0.2-2":"it-IT" }}
              </p>
            </div>
            <h5>
              <strong>Provincia:</strong> {{ tenderCard.province }}<br />
              <strong>Stato Gara</strong>:
              {{ getTenderStatusDesciption(tenderCard.tenderStatus) }}<br />
              <strong>Attuale migliore Offerta</strong>:
              {{
                tenderCard.bestOffer
                  ? tenderCard.bestOffer
                  : "Informazione Riservata"
              }}<br />
              <strong>Descrizione</strong>: {{ tenderCard.description }}<br />
              <strong>Data presunta Inizio</strong>:
              {{ getFormattedDate(tenderCard.expectedStartDate) }}<br />
              <strong>Data presunta Fine</strong>:
              {{ getFormattedDate(tenderCard.expectedEndDate) }}<br />
              <strong>Proponente</strong>: {{ tenderCard.customer }}<br />
              <strong>Subappalto</strong>:
              {{ tenderCard.subcontract ? "SI" : "NO" }}<br />
              <strong>Titoli abilitativi</strong>:
              {{
                tenderCard.qualifications
                  ? "Già ottenuti"
                  : "In fase di ottenimento"
              }}<br />
              <div *ngIf="tenderCard.maximumEstimateDate">
                <strong>Tempo massimo formulazione offerta:</strong>
                {{ getFormattedDate(tenderCard.maximumEstimateDate) }}
                <span *ngIf="tenderCard.maximumEstimateHour">
                  entro le ore {{ tenderCard.maximumEstimateHour }}<br />
                </span>
              </div>
              <div *ngIf="tenderCard.minimumRequirements.length > 0">
                <strong>Requisiti minimi di partecipazione</strong>:
                <br />
                <div
                  *ngFor="
                    let minimumRequirement of tenderCard.minimumRequirements
                  "
                >
                  <div style="margin-left: 10px">
                    {{ minimumRequirement.name }}:
                    {{ minimumRequirement.value }}
                  </div>
                </div>
              </div>
              <div *ngIf="tenderCard.minimumRequirements.length == 0">
                <strong>Requisiti Minimi</strong>: Nessun requisito minimo
                richiesto
              </div>
              <strong>Numero candidature residue</strong>:
              <span
                *ngIf="
                  tenderCard.remainingApplications == null ||
                  tenderCard.remainingApplications == undefined
                "
              >
                Nessun limite definito
              </span>
              <span
                *ngIf="
                  tenderCard.remainingApplications != null ||
                  tenderCard.remainingApplications != undefined
                "
              >
                {{ tenderCard.remainingApplications }}
              </span>
              <br />
            </h5>
          </div>

          <!-- <div class="fusion-sep-clear"></div>
                    <div class="fusion-separator fusion-full-width-sep sep-none"
                        style="margin-left: auto;margin-right: auto;margin-top:10px;"></div>
                    <div class="fusion-button-wrapper fusion-alignright">
                        <style type="text/css">
                            .fusion-button.button-2 {
                                border-radius: 0px;
                            }
                        </style><a (click)="buyParticipation(tenderCard)"
                            class="fusion-button button-flat fusion-button-default-size button-default button-2 fusion-button-default-span fusion-button-default-type"
                            target="_self"><span
                                class="fusion-button-text">PARTECIPA ALLA GARA</span></a>
                    </div>
                    <div class="fusion-clearfix"></div> -->
        </div>
        <div>
          <style type="text/css">
            @media only screen and (max-width: 800px) {
              .ng-ongoing-card-button {
                margin-top: 10px !important;
              }
            }
          </style>
          <div
            class="
              fusion-button-wrapper fusion-alignright
              ng-ongoing-card-button
            "
            style="padding: 0 30px 30px 0px; margin-top: -50px"
          >
            <style type="text/css">
              .fusion-button.button-2 {
                border-radius: 0px;
              }
            </style>
            <a
              (click)="buyParticipation(tenderCard)"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-2
                fusion-button-default-span fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text">PARTECIPA ALLA GARA</span></a
            >
          </div>
        </div>
      </div>
      <div style="font-weight:bold; margin: 20px; font-size:14px; color: #ffa626;">Le candidature spontanee, anche se previste, sono oggetto di valutazione del proponente per l'accettazione. In caso di mancata accettazione, Skimming provvederà a rilasciare un ristoro per partecipare gratuitamente ad un'altra gara d'appalto.</div>
    </div>
  </div>
</div>
<div class="fusion-builder-row fusion-row" *ngIf="showMoreTenders">
  <div class="fusion-text">
    <p style="text-align: right; padding-top: 25px; margin-bottom: 0">
      <a
        style="font-weight: 600; cursor: pointer"
        (click)="loadMoreOngoingTenders()"
        target="_self"
        >ALTRE GARE &gt;</a
      >
    </p>
  </div>
</div>

<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-5
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link),
  .fusion-fullwidth.fusion-builder-row-5
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):before,
  .fusion-fullwidth.fusion-builder-row-5
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-5
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover,
  .fusion-fullwidth.fusion-builder-row-5
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-5
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-5 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-5
    .fusion-filters
    .fusion-filter.fusion-active
    a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-5 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-5
    .fusion-filters
    .fusion-filter.fusion-active
    a,
  .fusion-fullwidth.fusion-builder-row-5
    .fusion-date-and-formats
    .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-5 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-5 .tooltip-shortcode {
    color: #ffa626;
  }

  #main
    .fusion-fullwidth.fusion-builder-row-5
    .post
    .blog-shortcode-post-title
    a:hover {
    color: #ffa626;
  }
</style>
<div
  class="
    fusion-fullwidth
    fullwidth-box
    fusion-builder-row-6 fusion-parallax-none
    nonhundred-percent-fullwidth
    non-hundred-percent-height-scrolling
  "
  style="
    background-color: #f5f5f5;
    background-image: url('/wp-content/uploads/2015/12/about-parallax-62758198-1024x630.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    padding-top: 0px;
    padding-right: 30px;
    padding-bottom: 70px;
    padding-left: 30px;
    border-top-width: 0px;
    border-bottom-width: 0px;
    border-color: #eae9e9;
    border-top-style: solid;
    border-bottom-style: solid;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  "
>
  <div class="fusion-builder-row fusion-row">
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_1
        fusion-builder-column-13
        fusion-one-full
        fusion-column-first
        fusion-column-last
        1_1
      "
      style="margin-top: 0px; margin-bottom: 0px"
    >
      <div
        class="fusion-column-wrapper"
        style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <div
          class="
            fusion-section-separator
            section-separator
            big-half-circle
            fusion-section-separator-with-offset
          "
          style="
            padding: 0;
            margin-left: calc((100vw - 100%) / -2);
            margin-right: calc((100vw - 100%) / -2);
          "
        >
          <svg
            class="fusion-big-half-circle-candy"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="100%"
            height="100"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            style="fill: #ffffff; padding: 0"
          >
            <path d="M0 0 C55 180 100 0 100 0 Z"></path>
          </svg>
        </div>
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 80px"
        ></div>
        <div class="fusion-clearfix"></div>
      </div>
    </div>
    <div
      class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_1
        fusion-builder-column-14
        fusion-one-full
        fusion-column-first
        fusion-column-last
        1_1
      "
      style="margin-top: 0px; margin-bottom: 0px"
    >
      <div
        class="fusion-column-wrapper"
        style="
          padding: 0px 15% 0px 15%;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        "
        data-bg-url=""
      >
        <div class="fusion-text">
          <h2 style="font-weight: 300; text-align: center">
            <span style="color: #ffffff">CREA UNA NUOVA GARA</span>
          </h2>
        </div>
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator sep-single sep-solid"
          style="
            border-color: #ffa626;
            border-top-width: 2px;
            margin-left: auto;
            margin-right: auto;
            margin-top: 0px;
            margin-bottom: 30px;
            width: 100%;
            max-width: 206px;
          "
        ></div>
        <div class="fusion-text">
          <p style="text-align: center">
            <span style="color: #ffffff"
              >Compila il form presente all'interno di maschere predisposte,
              stabilisci quali sono i requisiti minimi d'impresa richiesti,
              aggiungi tutti gli allegati che ritieni necessari, fornisci le
              dovute informazioni  per catturare l'interesse degli imprenditori
              e pubblica il tutto sul Web con l'ausilio di Skimming.</span
            >
          </p>
        </div>
        <div class="fusion-sep-clear"></div>
        <div
          class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 30px"
        ></div>
        <div class="fusion-button-wrapper fusion-aligncenter">
          <style type="text/css">
            .fusion-button.button-6 {
              border-radius: 0px;
            }</style
          ><a
            (click)="goToNewTender()"
            class="
              fusion-button
              button-flat
              fusion-button-default-size
              button-default button-6
              fusion-button-default-span fusion-button-default-type
            "
            target="_self"
            ><span class="fusion-button-text">CREA UNA NUOVA GARA</span></a
          >
        </div>
        <div class="fusion-clearfix"></div>
      </div>
    </div>
  </div>
</div>
<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-6
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link),
  .fusion-fullwidth.fusion-builder-row-6
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):before,
  .fusion-fullwidth.fusion-builder-row-6
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-6
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover,
  .fusion-fullwidth.fusion-builder-row-6
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-6
    a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-6 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-6
    .fusion-filters
    .fusion-filter.fusion-active
    a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-6 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-6
    .fusion-filters
    .fusion-filter.fusion-active
    a,
  .fusion-fullwidth.fusion-builder-row-6
    .fusion-date-and-formats
    .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-6 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-6 .tooltip-shortcode {
    color: #ffa626;
  }

  #main
    .fusion-fullwidth.fusion-builder-row-6
    .post
    .blog-shortcode-post-title
    a:hover {
    color: #ffa626;
  }
</style>
<!-- UNAUTHORIZED MODAL -->
<app-modal #unauthorizedModal>
  <ng-template #header>
    <div
      class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"
    ></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>{{ "Per accedere a quest area è necessario compilare tutti i dati del profilo azienda all'interno dell'area riservata" | uppercase }}</h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div
        class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        "
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 100%;
          width: calc(100% - ((1%) * 0.5));
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-22"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-right: 4%;
          "
          data-bg-url=""
        >
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a
              (click)="unauthorizedModalSubmit()"
              class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              "
              target="_self"
              ><span class="fusion-button-text fusion-button-text-left">{{
                "APRI LA PAGINA DI PROFILO"
              }}</span></a
            >
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>
